export enum VerifiedStatus {
    NO_STATUS = 'NO_STATUS',
    FAILED = 'FAILED',
    WAITING_VERIFY = 'WAITING_VERIFY',
    UNVERIFIED = 'UNVERIFIED',
    VERIFIED = 'VERIFIED',
}
